import { Button, ButtonProps } from "@chakra-ui/react";

interface TabButtonProps extends ButtonProps {
    active: Boolean;
}
export default function TabButton({ active, children, ...props }: TabButtonProps) {
    return (
        <Button
            px={6}
            size={'sm'}
            bg={active ? "primary.600" : 'gray.200'}
            color={active ? "white" : "primary.900"}
            _hover={{ bg: active ? 'primary.700' : "gray.300" }}
            _active={{ bg: active ? 'primary.800' : "gray.400" }}
            {...props}
        >
            {children}
        </Button>
    )
}